import React from 'react'
import { Link } from 'react-router-dom'
import { useTranslation } from 'react-i18next' // I18N
// import abImg1 from '../../images/about/img-1.jpg'
import abImg1 from '../../images/about/img-1 (2).jpg'
// import abImg2 from '../../images/about/img-2.jpg'
import abImg2 from '../../images/about/img-2 (2).jpg'
import GallerySection from './gallerySection'
import SuccessStorySection from './SuccessStorySection'
import PartnersSection from '../PartnersSection/PartnersSection'

const About = (props) => {
    const { t } = useTranslation(); // I18N

    const ClickHandler = () => {
        window.scrollTo(10, 0);
    }
    

    return (
        <section className="wpo-about-section section-padding">
            <div className="container">
                <div className="wpo-about-wrap">
                    <div className="row align-items-center">
                        <div className="col-lg-6 col-md-12 col-12">
                            <div className="wpo-about-img">
                                <div className="wpo-about-left">
                                    <img src={abImg2} alt="img"  style={{ height: "250px", width:"400px", borderRadius:"10px" }}  />
                                </div>
                                <div className="wpo-about-right">
                                    <img src={abImg1} alt="img" style={{ height: "250px", width:"300px", borderRadius:"10px" }} />
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-6 col-md-12 col-12">
                            <div className="wpo-about-text">
                                <div className="wpo-section-title">
                                    <span>{t('about.welcomeTo')}</span>
                                    <h1 style={{fontWeight:"600"}}>{t('about.headline')}</h1>
                                </div>
                                <p>{t('about.intro')}</p>

                                <div className="about-info-wrap">
                                    <div className="about-info-item">
                                        
                                        <div className="about-info-text ">
                                        <div className="about-info-icon">
                                            <div className="icon">
                                             <i className="fi fa-solid fa-bullseye " ></i>
                                            </div>
                                        </div>
                                            <h4>{t('about.mission')}</h4>
                                           <div> <p>{t('about.missionBody')}</p></div>
                                        </div>
                                    </div>
                                    <div className="about-info-item">
                                        
                                        <div className="about-info-text">
                                        <div className="about-info-icon">
                                            <div className="icon">
                                              <i className="fi fa-solid fa-mountain"></i>
                                            </div>
                                        </div>
                                            <h4>{t('about.vision')}</h4>
                                            <p>{t('about.visionBody')}</p>
                                        </div>
                                    </div>
                                </div>

              
                            </div>
                            
                        </div>

<div style={{ marginTop: '50px', padding: '0 20px' }}>
    <div className="row ">

        {/* Section 1 */}
        <div className="col-12 col-sm-6 col-md-6">
            <div style={{
                backgroundColor: '#2C3E50', padding: '30px', marginBottom: '30px', borderRadius: '8px',
                boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)', textAlign: 'center', transition: 'transform 0.3s ease-in-out'
            }} onMouseOver={e => e.currentTarget.style.transform = 'translateY(-10px)'} onMouseOut={e => e.currentTarget.style.transform = 'translateY(0)'}>

                <div style={{
                    display: 'flex', flexDirection:"column", alignItems: 'center', justifyContent: 'center', marginBottom: '20px'
                }}>
                    <i className="fas fa-globe-americas" style={{ fontSize: '35px', color: '#00CC99', marginRight: '15px', marginBottom: '20px' }}></i>
                    <h3 style={{ fontSize: '24px', color: '#fff', fontWeight: '600' }}>{t('about.ourVision')}</h3>
                </div>

                <p style={{ fontSize: '16px', color: '#f0f3f6', lineHeight: '1.6' }}>
                    {t('about.ourVisionBody')}
                </p>
            </div>
        </div>

        {/* Section 2 */}
        <div className="col-12 col-sm-6 col-md-6">
            <div style={{
                backgroundColor: '#2C3E50', padding: '30px', marginBottom: '30px', borderRadius: '8px',
                boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)', textAlign: 'center', transition: 'transform 0.3s ease-in-out'
            }} onMouseOver={e => e.currentTarget.style.transform = 'translateY(-10px)'} onMouseOut={e => e.currentTarget.style.transform = 'translateY(0)'}>

                <div style={{
                    display: 'flex', flexDirection:"column", alignItems: 'center', justifyContent: 'center', marginBottom: '20px'
                }}>
                    <i className="fas fa-users" style={{ fontSize: '35px', color: '#00CC99', marginRight: '15px', marginBottom: '20px' }}></i>
                    <h3 style={{ fontSize: '24px', color: '#fff', fontWeight: '600' }}>{t('about.ourCommunity')}</h3>
                </div>

                <p style={{ fontSize: '16px', color: '#f0f3f6', lineHeight: '1.6' }}>
                    {t('about.ourCommunityBody')}
                </p>
            </div>
        </div>

    

    </div>
    <div className="row  ">

      
        {/* Section 3 */}
        <div className="col-12 col-sm-6 col-md-6">
            <div style={{
                backgroundColor: '#2C3E50', padding: '30px', marginBottom: '30px', borderRadius: '8px',
                boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)', textAlign: 'center', transition: 'transform 0.3s ease-in-out'
            }} onMouseOver={e => e.currentTarget.style.transform = 'translateY(-10px)'} onMouseOut={e => e.currentTarget.style.transform = 'translateY(0)'}>

                <div style={{
                    display: 'flex', flexDirection:"column", alignItems: 'center', justifyContent: 'center', marginBottom: '20px'
                }}>
                    <i className="fas fa-hand-holding-heart" style={{ fontSize: '35px', color: '#00CC99', marginRight: '15px', marginBottom: '20px' }}></i>
                    <h3 style={{ fontSize: '24px', color: '#fff', fontWeight: '600' }}>{t('about.ourCommitment')}</h3>
                </div>

                <p style={{ fontSize: '16px', color: '#f0f3f6', lineHeight: '1.6' }}>
                    {t('about.ourCommitmentBody')}
                </p>
            </div>
        </div>

        {/* Section 4 */}
        <div className="col-12 col-sm-6 col-md-6">
            <div style={{
                backgroundColor: '#2C3E50', padding: '30px', marginBottom: '30px', borderRadius: '8px',
                boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)', textAlign: 'center', transition: 'transform 0.3s ease-in-out'
            }} onMouseOver={e => e.currentTarget.style.transform = 'translateY(-10px)'} onMouseOut={e => e.currentTarget.style.transform = 'translateY(0)'}>

                <div style={{
                    display: 'flex', flexDirection:"column", alignItems: 'center', justifyContent: 'center', marginBottom: '20px'
                }}>
                    <i className="fas fa-calendar-check" style={{ fontSize: '35px', color: '#00CC99', marginRight: '15px', marginBottom: '20px' }}></i>
                    <h3 style={{ fontSize: '24px', color: '#fff', fontWeight: '600' }}>{t('about.ourFuture')}</h3>
                </div>

                <p style={{ fontSize: '16px', color: '#f0f3f6', lineHeight: '1.6' }}>
                   {t('about.ourFutureBody')}  </p>
            </div>
        </div>

    </div>
</div>

                       </div>     <SuccessStorySection />
                    <PartnersSection />
                    <GallerySection />
                </div>
            </div>
        </section>
    )
}

export default About;
